import Api from '../api/Api';
import resolve from  '../util/Configuracao';
class AcertoMensalidadeApi extends Api {
  async consultarTodosOsProtocolos () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosProtocolosAcertoMensalidade');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarOrigens () {
    try {
      const origensUrl = resolve('urlConsultarOrigensAcertoMensalidade');
      const response = await this.fetch(origensUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEstados () {
    try {
      const estadosAcertoUrl = resolve('urlConsultarEstadosAcertoMensalidade');
      const response = await this.fetch(estadosAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarAcertos (numProtocolo, numMatricula, codOrigem, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal) {
    let acertos = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    let botaoAnalisar = '';
    try {
      const acertoUrl = resolve('urlConsultarAcertosMensalidade') +
      numProtocolo + '/' +
      numMatricula + '/' +
      codOrigem + '/' +
      codEstado + '/' +
      numProcesso + '/' +
      anoProcesso + '/' +
      dataInicial + '/' +
      dataFinal;
      const { data } = await this.fetch(acertoUrl, 'post');
    data.map(res => {
      const { numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codOrigem, desOrigem, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numProcesso, anoProcesso, valPago, valCorreto, indCancelado, historicos, desSituacao, txtProcessoSei } = res;
      const numAnoProc = numProcesso + '/' + anoProcesso;
      brancoAcoes = indCancelado;
      if (codEstado === 4) {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        if (codEstado === 1 || codEstado === 2) {
          tipoBotaoCancelamento = 'CANCELAR';
        } else {
          tipoBotaoCancelamento = 'NENHUM';
        }
      }
      if (codEstado === 1) {
        botaoAnalisar = 'ANALISAR';
      } else {
        botaoAnalisar = 'NENHUM';
      }
      acertos.push(Object.values({ numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codOrigem, desOrigem, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numAnoProc, valPago, valCorreto, indCancelado, historicos, anoProcesso, numProcesso, tipoBotaoCancelamento, botaoAnalisar, brancoAcoes, desSituacao, txtProcessoSei }));
    });
    return acertos || [];
    } catch (error) {
      console.error(error);
    }

  }
  async incluirAcerto (acerto) {
    try {
      const urlIncluirAcerto = resolve('urlIncluirAcerto');
      const response = await this.fetch(urlIncluirAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarAcerto (acerto) {
    try {
      const urlAlterarAcerto = resolve('urlAlterarAcerto');
      const response = await this.fetch(urlAlterarAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcertosEmLote (acertos) {
    try {
      const urlExcluirAcertos = resolve('urlExcluirAcertos');
      const result = await this.fetch(urlExcluirAcertos, 'post', acertos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async processarAcerto (numProtocolo) {
    try {
      const urlProcessarAcerto = resolve('urlProcessarAcerto') + numProtocolo;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarAcerto (numProtocolo, motivoCancelamento) {
    try {
      const urlCancelarAcerto = resolve('urlCancelarAcerto') + numProtocolo + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoAcerto (numProtocolo) {
    try {
      const urlDesfazerCancelamentoAcerto = resolve('urlDesfazerCancelamentoAcerto') + numProtocolo;
      const response = await this.fetch(urlDesfazerCancelamentoAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async analisarAcerto (numProtocolo) {
    try {
      const urlAnalisarAcerto = resolve('urlAnalisarAcerto') + numProtocolo;
      const response = await this.fetch(urlAnalisarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcerto (numProtocolo) {
    try {
      const urlExcluirAcerto = resolve('urlExcluirAcerto') + numProtocolo;
      const response = await this.fetch(urlExcluirAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AcertoMensalidadeApi;
